import React from 'react'
import Grid from '@material-ui/core/Grid'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { makeStyles } from '@material-ui/core/styles'
import { useMergedState } from 'hooks'
import { Expansible, Input } from 'components'
import TabPanel from './TabPanel'

const styles = makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(4),
  },
  conta: {
    color: `black`,
  },
}))

export default function TabsView({ active, tabsContent, fieldsById, dispatcher, hidden=false, ...rest }) {
  const classes = styles()
  const [{ openTab }, setState] = useMergedState({
    openTab: active,
  })
  function handleTabChange(_, nextTab) {
    dispatcher({
      type: `ACTIVE_TAB_CHANGE`,
      payload: nextTab,
    })
    setState({ openTab: nextTab })
  }

  const namesTab = {
    'pt-br': `Portugues`,
    it: `Italiano`,
    fr: `Frances`,
    de: `Aleman`,
    en: `English`,
    es: `Español`,
  }

  return hidden ? <></> :(
    <Grid container alignContent="flex-start" alignItems="flex-start" className={classes.container}>
      <Grid container alignItems="center">
        <Tabs value={openTab} onChange={handleTabChange} variant="fullWidth" textColor="primary">
          {Object.keys(tabsContent).map((tabIdentifier, index) => {
            const { tabName, disabled } = tabsContent[tabIdentifier]
            const id = `tab-${index}-${tabName}-${tabIdentifier}`
            return (
              <Tab
                key={id}
                label={namesTab[tabName]}
                id={id}
                disabled={disabled}
                value={tabIdentifier}
                disableRipple
              />
            )
          })}
        </Tabs>
      </Grid>
      {Object.keys(tabsContent).map((tabIdentifier, index) => {
        const { tabsSections, languageKey } = tabsContent[tabIdentifier]
        return (
          <TabPanel key={`tab-${index}`} openTab={openTab} tabValue={tabIdentifier}>
            {tabsSections.map(({ ...sectionProps }, panelIndex) => {
              return (
                <Expansible {...sectionProps} key={`panel-${panelIndex}`} internal>
                  {sectionProps.fieldsIds.map((fieldId, index) => (
                    <Input
                      {...fieldsById[fieldId]}
                      {...rest}
                      key={`panel-${panelIndex}-${fieldId}-${index}`}
                      id={fieldId}
                      fieldsById={fieldsById}
                      languageKey={languageKey}
                    />
                  ))}
                </Expansible>
              )
            })}
          </TabPanel>
        )
      })}
    </Grid>
  )
}
